<template>
  <div class="content-main">

    <div class="shanzha">

      <!-- <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <span>{{$store.state.siteSlogan}}</span>
      </div> -->

      <!-- <div v-if="published" class="postcard-rule-v2 flex-box">
        <span class="rule-dot">•</span><span class="rule-text">点击查看明信片寄出规则 ！！！</span>
      </div> -->

      <div class="infos">
        <van-list
          class = "infos-list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了~"
          @load="onLoad">

          <div class="info-item" v-for="info in infos" :key="info.id">
            <div class="userinfo flex-box">
              <!-- <div class="headimg-nickname flex-box">
                <img class="headimg" :src="info.headimgurl">
                <div class="nickname">{{info.nickname}}</div>
              </div> -->
              <div class="date">写信时间：{{info.create_time}}</div>
              <div class="tags flex-box">
                <div v-if="info.type == 'wechat' && info.pid == '' " class="delivery-status wechat" @click="applyPostcard">申请寄出</div>
                <div v-if="info.type == 'postcard'" class="delivery-status postcard">纸质明信片</div>
                <div v-if="info.status == 0 && info.pid" class="delivery-status unsent">待寄出</div>
                <div v-if="info.status == 1 && info.pid" class="delivery-status sent">已寄出</div>
                <div v-if="info.status == 1 && info.pid" class="delivery-status company">{{info.company}}</div>
              </div>
            </div>
            <div class="info-content">To: {{info.receiver}}</div>
            <div class="info-content" style="white-space: pre-wrap;text-indent:1em;margin-top:5px;margin-bottom:5px;">{{info.content}}</div>
            <!-- <div class="info-content" style="text-align:right;">From: {{info.sender}}</div> -->
            <div class="delivery-date-and-trackingno flex-box">
              <div v-if="info.pid" class="info-content delivery-date" style="color:#a0a0a0;">寄信时间：{{info.send_time}}</div>
              <div v-if="info.trackingno" class="info-content trackingno" style="color:#a0a0a0;">快递单号:{{info.trackingno}}</div>
              <div class="flex-box">
                <div v-if="info.status == 0 && info.type == 'wechat'" class="box-delete flex-box" @click="showDeleteDialog(info.id)"><van-icon name="delete" /><span class="delete-text">删除</span></div>
                <div v-if="!info.trackingno && info.type == 'postcard'" class="info-content edit" style="color:#a0a0a0;" @click="goMailRevise(info.pid)"><van-icon name="edit" />修改</div>
              </div>
            </div>
          </div>

        </van-list>
      </div>

      <van-tabbar v-model="tabActive" active-color="#b17e94">
        <van-tabbar-item icon="wap-home" @click="goHome()">广场</van-tabbar-item>
        <van-tabbar-item icon="envelop-o" @click="goMailCreate()">写信</van-tabbar-item>
        <van-tabbar-item icon="manager-o">个人中心</van-tabbar-item>
      </van-tabbar>

    </div>

    <!-- %{
    sender: info.sender, reciver: info.receiver, content: info.content, create_time: create_time,
    send_time: send_time,  status: info.delivery, trackingno: trackingno} -->
    <!-- <div class="btn-check flex-box" @click="goMailCreate()"><div class="btn-txt flex-box"><div>开始</div><div>写信</div></div></div> -->

  </div>
</template>

<script>
import { Toast, List, Popup, Tabbar, TabbarItem, Icon, Dialog } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [List.name]: List,
    [Popup.name]: Popup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog
  },
  data(){
    return {
      infos: [],
      next_page: 1,
      total_entries: 1,
      total_pages: 1,
      finished: false,
      loading: false,
      tabActive: 2
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    onLoad() {
      this.loading = true
      this.getMsgs()
    },
    getMsgs(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/momentbox/get_userself_mails_v2', {page: this.next_page, openid: openid}, res => {
        if(res.code == 200 && res.infos){
          this.infos = this.infos.concat(res.infos)
          this.total_entries = res.paginate.total_entries
          this.next_page = this.next_page + 1
          this.total_pages = res.paginate.total_pages
          if(this.next_page > this.total_pages){
            this.finished = true
          }
        }
        this.loading = false
      })
    },
    goHome(){
      this.$router.replace("/?referal=" + this.$store.state.referal)
    },
    goMailCreate(){
      this.$router.replace("/mail_create?referal=" + this.$store.state.referal)
    },
    goUserCenter(){
      this.$router.replace("/mails_records?referal=" + this.$store.state.referal)
    },
    setReferal(){
      let searchParams = new URLSearchParams(window.location.search)
      if(searchParams.get("referal")){
        this.$store.commit('setReferal', { referal: searchParams.get("referal") })
      }
    },
    goMailRevise(pid){
      this.handleRouter('/mail_revise/' + pid)
    },
    showDeleteDialog(info_id){
      Dialog.confirm({
        title: '删除提醒',
        message: '是否要删除该信件，删除以后将取消寄出'
      }).then(() => {
        // on confirm
        this.deleteMessage(info_id)
      }).catch(() => {
        // on cancel
      });
    },
    deleteMessage(info_id){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/momentbox/delete_info_by_user', {info_id: info_id, openid: openid}, res => {
        if(res.code == 200){
          Toast('删除成功！')
          this.infos = []
          this.next_page = 1
          this.getMsgs()
        }
      })
    },
    applyPostcard(){
      window.location.href = "https://mp.weixin.qq.com/s/HKzPQbCDWXcA1MDt_D28CA"
    }
  },
  mounted(){
    this.setReferal()
  }
}
</script>

<style scoped>
.content-main{min-height:100vh;background-color: #f8f8f8;color:#b17e94;}
.shanzha{padding:20px;}
.logo-and-wish{padding:15px 0px;font-size:30px;margin-bottom:20px;}
.logo{height:150px;width:150px;border-radius:150px;margin-right:35px;}
.btn-check{
  width:120px;height:120px;border-radius:120px;background:#b17e94;position:fixed;
  bottom:100px;right:40px;color:#fff;justify-content:center;
}
.btn-txt{
  flex-direction: column;justify-content:center;width:102px;height:102px;border:2px solid #fff;
  border-radius:102px;font-size:25px;
}
.postcard-rule-v2{background:#fff;margin-bottom:20px;height:120px;padding-left:30px;justify-content: flex-start;}
.postcard-rule-v2 .rule-dot{color:#f39c12;margin-right:10px;font-size:60px;}
.postcard-rule-v2 .rule-text{color:#333;font-size:28px;}
.infos{background:#f8f8f8;text-align:left;color:#b17e94;}
.infos .info-item{
  padding:20px;color:#a0a0a0;margin-bottom:20px;background:#fff;border-radius:15px;
  box-shadow:0px 2px 6px rgba(0,0,0,0.15);
}
.infos .userinfo{font-size:24px;justify-content:space-between;align-items:center;margin-bottom:20px;}
.infos .nickname{color:#333;}
.infos .headimg{width:50px;height:50px;border-radius:50px;margin-right:20px;}
.infos .info-content{font-size:26px;color:#666;}
.infos .info-content.delivery-date{font-size:24px;}
.infos .delivery-date-and-trackingno{font-size:24px;justify-content:space-between;margin-top:10px;}
.infos .delivery-date-and-trackingno .trackingno{font-size:24px;}
.infos .delivery-date-and-trackingno .edit{font-size:24px;}

.delivery-status{border-radius:10px;padding:2px 10px;font-size:24px;}
.delivery-status.unsent{color:#f39c12;border:2px solid #f39c12;}
.delivery-status.sent{color:#0f88eb;border:2px solid #0f88eb;}
.delivery-status.company{color:#4caf50;border:2px solid #4caf50;margin-left:15px;}
.delivery-status.wechat{color:#00a65a;border:2px solid #00a65a;margin-right:15px;}
.delivery-status.postcard{color:#9747ff;border:2px solid #9747ff;margin-right:15px;}

.box-delete .delete-text{margin-left:10px;}
</style>
